import { render, staticRenderFns } from "./MainHero.vue?vue&type=template&id=64276da8&scoped=true&"
var script = {}
import style0 from "./MainHero.vue?vue&type=style&index=0&id=64276da8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64276da8",
  null
  
)

export default component.exports